import { FC } from "react";
import { StatusIndicator } from "../../Components/StatusIndicator/StatusIndicator";

type Props = {
  /** Missing BC data is unknown, rather than an explicitly hidden product. */
  enabled: boolean | null;
  isGroup?: boolean;
};

/** Read-only BC eligibility, displayed separately from the PIM publication control. */
export const WebshopStatus: FC<Props> = ({ enabled, isGroup = false }) => (
  <StatusIndicator
    label={
      enabled === null ? "Ukendt" : enabled ? "Aktiv i shop" : "Skjult i shop"
    }
    color={enabled === true ? "#278047" : "#777"}
    title={
      isGroup
        ? "Beregnet fra alle varianter: Aktiv når mindst én variant er aktiveret i BC."
        : undefined
    }
  />
);
